import { createComponent } from '@carvana/vdp-components';
import FavoriteVehicle from './FavoriteVehicle/FavoriteVehicle';
import Pills from './Pills';
import Tags from './Tags';
import VehicleImage from './VehicleImage/VehicleImage';

const FirstRowWrapper = createComponent('section', {
  className:
    'box-border grid grid-flow-row grid-rows-[min-content,max-content] relative'
});

const ContentWrapper = createComponent('div', {
  className: 'col-[1_/_3] grid relative'
});

const FirstRow = () => {
  return (
    <FirstRowWrapper>
      <VehicleImage />
      <ContentWrapper>
        <Tags />
        <FavoriteVehicle />
        <Pills />
      </ContentWrapper>
    </FirstRowWrapper>
  );
};

export default FirstRow;
